var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect } from 'react';
import { withPhoneNumbers } from 'hocs';
export const NumberTableContext = createContext(null);
export const useNumberTable = () => {
    const context = useContext(NumberTableContext);
    if (!context) {
        throw new Error('Missing NumberTableProvider');
    }
    return context;
};
const NumberTableProvider = (_a) => {
    var { children } = _a, context = __rest(_a, ["children"]);
    const { phoneNumbers: { getItems }, } = context;
    useEffect(() => void getItems(), [getItems]);
    return (_jsx(NumberTableContext.Provider, Object.assign({ value: context }, { children: children })));
};
export default withPhoneNumbers(NumberTableProvider);
